import { render, staticRenderFns } from "./zone.vue?vue&type=template&id=39fff924&scoped=true"
import script from "./zone.vue?vue&type=script&lang=js"
export * from "./zone.vue?vue&type=script&lang=js"
import style0 from "./zone.vue?vue&type=style&index=0&id=39fff924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fff924",
  null
  
)

export default component.exports